// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2Obrp","obliqueLineWrap":"membershipbadge_obliqueLineWrap__372LT","obliqueLine":"membershipbadge_obliqueLine__3vKZ3"};